import { withHandlers } from 'recompose'
import { setActiveLocation, setMapBounds } from 'map/actions'
import { activeLocationSelector, zoomSelector, clustersPOISelector } from 'map/selectors'
import ClusterBaseMarker from 'map/components/cluster/Cluster'

export default compose(
    connect(
        createStructuredSelector({
            activeLocation: activeLocationSelector,
            zoom: zoomSelector,
            clusters: clustersPOISelector,
        }),
        {
            setActiveLocation,
            setMapBounds,
        }
    ),
    withHandlers({
        onClick: ({ cluster_id, clusters, lat, lng, zoom, setMapBounds }) => () =>
            setMapBounds({ lat, lng }, clusters.getClusterExpansionZoom(cluster_id, zoom) + 1),
    })
)(ClusterBaseMarker)
